// extracted by mini-css-extract-plugin
export default {"upcomming-events-area":"UpcommingEvents_upcomming-events-area__V8c+M","events-header":"UpcommingEvents_events-header__AH6MW","events-section":"UpcommingEvents_events-section__Y1lmE"};